// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"4fac7de7","787":"ed090fd3"}[chunkId] + ".chunk.js";
};